export function isEmail(s) {
  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
    s
  );
}

export function isMobile(s) {
  return /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/.test(s);
}

export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s);
}

export function onlyEnglish(s) {
  return /^[a-zA-Z]*$/.test(s);
}

export function checkTextLength(s, minLen, maxLen) {
  let result = false;
  if (s) {
    if (s.length >= minLen && s.length <= maxLen) {
      result = true;
    } else {
      result = false;
    }
  }
  return result;
}

export function isNotEmpty(s) {
  let result = false;
  if (s !== null && s !== "") {
    result = true;
  }
  return result;
}

export function isNumber(s) {
  return !isNaN(s);
}

export function checkPassword(s) {
  return /^.*(?=.{8,20})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?]).*$/.test(
    s
  );
}

export function checkRegNumber(s) {
  return /([0-9]{3})-([0-9]{2})-([0-9]{5})/.test(s);
}

export function checkUserID(s) {
  return /^[a-zA-Z0-9_-]{2,20}$/.test(s);
}
